export const adaptAnnouncement = (data: IAnnouncement): MeeAnnouncement => {
	return {
		id: data.id,
		title: data.title,
		body: data.body,
		contentBlocks: data.content_blocks,
		heroImage: data.hero_image,
		pushTitle: data.push_title,
		pushBody: data.push_body,
		status: data.status,
		audienceType: data.audience_type,
		audiencePlatform: data.audience_platform,
		audienceUserIds: data.audience_user_ids,
		scheduledAt: data.scheduled_at,
		expiresAt: data.expires_at,
		sentAt: data.sent_at,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptAnnouncements = (
	data: IAnnouncement[]
): MeeAnnouncement[] => {
	return data.map(adaptAnnouncement);
};

export const adaptAnnouncementAnalytics = (
	data: IAnnouncementAnalytics
): AnnouncementAnalytics => {
	return {
		totalRecipients: data.total_recipients,
		readCount: data.read_count,
		users: data.users.map((user) => ({
			id: user.id,
			firstName: user.first_name,
			lastName: user.last_name,
			department: user.department,
			read: user.read,
			readAt: user.read_at
		}))
	};
};
